export { default } from './src';
export type { UniformBodyContentProps } from './src/body-content';
